const ONE_DAY_MS = 86400 * 1000;

/** @returns {'countdown' | 'live' | 'finished' | 'none'} */
export function webinarHeroStatusKind(startDatetime) {
	if (!startDatetime) {
		return "none";
	}
	const startMs = new Date(startDatetime).getTime();
	if (Number.isNaN(startMs)) {
		return "none";
	}
	const now = Date.now();
	if (now < startMs) {
		return "countdown";
	}
	if (now < startMs + ONE_DAY_MS) {
		return "live";
	}
	return "finished";
}

export function secondsUntilWebinarStart(startDatetime) {
	if (!startDatetime) {
		return 0;
	}
	const startMs = new Date(startDatetime).getTime();
	if (Number.isNaN(startMs)) {
		return 0;
	}
	return Math.max(Math.floor((startMs - Date.now()) / 1000), 0);
}

export function formatWebinarCountdown(seconds) {
	const remaining = Math.max(Number(seconds) || 0, 0);
	if (!remaining) {
		return "";
	}
	const days = Math.floor(remaining / 86400);
	const hours = Math.floor((remaining % 86400) / 3600);
	const minutes = Math.floor((remaining % 3600) / 60);
	const secondsLeft = remaining % 60;
	return `${days > 0 ? `${days} روز و ` : ""}${hours} ساعت و ${minutes} دقیقه و ${secondsLeft} ثانیه تا شروع`;
}

export function webinarHeroStatusLabel(kind) {
	if (kind === "live") {
		return "وبینار شروع شده است";
	}
	if (kind === "finished") {
		return "تمام شده";
	}
	return "";
}

/** برچسب کارت وبینار در صفحه اصلی: تاریخ قبل از شروع، بعد «شروع شده» / «تمام شده». */
export function webinarCardStatusLabel(startDatetime, jStartDatetime = "") {
	const kind = webinarHeroStatusKind(startDatetime);
	if (kind === "countdown") {
		return jStartDatetime || "";
	}
	if (kind === "live") {
		return "شروع شده";
	}
	if (kind === "finished") {
		return "تمام شده";
	}
	return jStartDatetime || "";
}
